import Scipy from "../images/scipy.png"
import Sql from "../images/SQL Developer.png"
import xgboost from "../images/xgboost.png"
import Flask from "../images/Flask.png"
import Django from "../images/Django.png"
import Kubernates from "../images/Kubernetes.png"
import streamlit from "../images/Streamlit.png"
import Jupyter from "../images/Jupyter.png"
import Pycharm from "../images/PyCharm.png"
import Plotly from "../images/Ploty.png"
export const Bio = {
    name: "Tushar Dupare",
    roles: [
      "Data Analyst",
      "Data Scientist",
      "Power BI Developer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/TusharD48",
    resume:
      "https://drive.google.com/file/d/10p7i7yc-ExOioV_iF1ZG1ckUeOr3iqPX/view?usp=drive_link",
    linkedin: "https://www.linkedin.com/in/tushar-dupare-b0ba75155/",
    HackerRank: "https://www.hackerrank.com/profile/tushardupare26",
    insta: "https://www.instagram.com/_tusharrrr08/",
    facebook: "https://www.facebook.com/tusudupare/",
  };
  
  export const skills = [
    {
      title: "Data Processing & Analysis",
      skills: [
        {
          name: "Pandas",
          image:
            "https://img.icons8.com/?size=100&id=xSkewUSqtErH&format=png&color=000000",
        },
        {
          name: "NumPy",
          image:
            "https://img.icons8.com/?size=100&id=aR9CXyMagKIS&format=png&color=000000",
        },
        {
          name: "Matplotlib",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/8/84/Matplotlib_icon.svg",
        },
        {
          name: "Scipy",
          image:
            Scipy,
        },
        {
          name: "Excel",
          image:
            "https://img.icons8.com/?size=100&id=117561&format=png&color=000000",
        },
      ],
    },
    {
      title: "Programming Languages",
      skills: [
        {
          name: "Python",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg",
        },
        {
          name: "SQL",
          image:
            Sql,
        },
        {
          name: "JavaScript",
          image:
            "https://static.vecteezy.com/system/resources/previews/027/127/560/non_2x/javascript-logo-javascript-icon-transparent-free-png.png",
        },
        {
          name: "HTML 5",
          image:
            "https://img.icons8.com/?size=100&id=20909&format=png&color=000000",
        },
      ],
    },
    {
      title: "Machine Learning",
      skills: [
        {
          name: "scikit-learn",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
        },
        {
          name: "TensorFlow",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
        },
        {
          name: "Keras",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/a/ae/Keras_logo.svg",
        },
        {
          name: "PyTorch",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/1/10/PyTorch_logo_icon.svg",
        },
        {
          name: "XGBoost",
          image:
            xgboost,
        },
      ],
    },
    {
      title: "Data Visualization",
      skills: [
        {
          name: "Matplotlib",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/8/84/Matplotlib_icon.svg",
        },
        {
          name: "Seaborn",
          image:
            "https://seaborn.pydata.org/_images/logo-tall-lightbg.svg",
        },
        {
          name: "Tableau",
          image:
            "https://img.icons8.com/?size=100&id=9Kvi1p1F0tUo&format=png&color=000000",
        },
        {
          name: "Power BI",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg",
        },
        {
          name: "Plotly",
          image:
            Plotly,
        },
      ],
    },
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Next Js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
      ],
    },
    {
      title: "Model Deployment",
      skills: [
        {
          name: "Flask",
          image:
            Flask,
        },
        {
          name: "Streamlit",
          image:
            streamlit,
        },
        {
          name: "Django",
          image:
            Django,
        },
        {
          name: "Kubernates",
          image:
            Kubernates,
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
      ],
    },
    {
      title: "Integrated Development Environments (IDEs)",
      skills: [
        {
          name: "Jupyter Notebook",
          image:
            Jupyter,
        },
        {
          name: "Google Colab",
          image:
            "https://img.icons8.com/?size=100&id=lOqoeP2Zy02f&format=png&color=000000",
        },
        {
          name: "Pycharm",
          image:
            Pycharm,
        },
        {
          name: "Spyder",
          image:
            "https://img.icons8.com/?size=100&id=0S1Hoidfnk7H&format=png&color=000000",
        },
        {
          name: "VsCode",
          image:
            "https://img.icons8.com/?size=100&id=9OGIyU8hrxW5&format=png&color=000000",
        },
      ],
    }
  ];
  
  
  export const experiences = [
    {
      id: 0,
      img: "https://nedient.co.in/static/website/assets/img/logo/nedient.png",
      role: "Data Science Intern",
      company: "Nedient Technology Pvt. Ltd.",
      date: "Apr 2024 - Sept 2024",
      desc: "Worked on developing and deploying machine learning models for predictive analytics. Managed data pipelines and automated ETL processes.",
      skills: [
        "Python",
        "Pandas",
        "NumPy",
        "Scikit-Learn",
        "TensorFlow",
        "Keras",
        "SQL",
        "AWS",
        "Docker",
      ]
    },
    {
      id: 1,
      img: "https://spinnakerwebsiteassets.s3.amazonaws.com/spinnakeranalytics.com/images/logo/spinnaker-analytics-icon-white.webp",
      role: "Data Analyst Intern",
      company: "Spinnaker Analytics",
      date: "Aug 2024 - Present",
      desc: "Performed data cleaning, analysis, and visualization to derive insights from automobile data. Assisted in building dashboards and reports.",
      skills: [
        "Python",
        "SQL",
        "Tableau",
        "Power BI",
        "Excel",
        "R",
        "Seaborn",
        "Matplotlib",
      ],
      // doc: "https://firebasestorage.googleapis.com/v0b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
    },
    {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
      role: "Open Source Contributor",
      company: "GirlScript Summer of Code",
      date: "May 2023 - Present",
      desc: "Contributing to various open-source data science projects, focusing on data analysis, machine learning, and data visualization.",
      doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    },
  ];
  
  
  export const education = [
    {
      id: 0,
      img: "https://collegesdirectory.in/World/MasterAdmin/College-Master/College_Logo/Logo-1528064663.png",
      school: "Rashtrasant Tukdoji Maharaj Institute",
      date: "May 2017 to Oct 2020",
      grade: "7.2 CGPA",
      desc: "I pursued a Bachelor's degree in Computer Science and Applications (B.C.C.A.) at Rashtrasant Tukdoji Maharaj Institute, Nagpur and passed out in October 2020. During my studies, I completed courses in Computer Programming, Data Structures, Software Engineering, Database Management Systems, Web Development, and Operating Systems, among others.",
      degree: "B.C.C.A.",
    },
    {
      id: 1,
      img: "https://upload.wikimedia.org/wikipedia/en/8/82/Jawahar_Navodaya_Vidyalaya_logo.png?20230306135753",
      school: "Jawahar Navodaya Vidyalaya, Chandrapur",
      date: "May 2015 - April 2017",
      grade: "75.6%",
      desc: "I completed my class 12 high school education at JNV School, Chandrapur, where I studied Science as PCM.",
      degree: "CBSE, Science",
    },
    {
      id: 2,
      img: "https://upload.wikimedia.org/wikipedia/en/8/82/Jawahar_Navodaya_Vidyalaya_logo.png?20230306135753",
      school: "Jawahar Navodaya Vidyalaya, Chandrapur",
      date: "May 2010 - Apr 2015",
      grade: "90.2%",
      desc: "I completed my class 10 education at JNV School, Chandrapur, where I studied Science with Computer Application.",
      degree: "CBSE, Science",
    },
  ];
  
  export const projects = [
    {
      id: 9,
      title: "Trackify",
      date: "Jun 2023 - Jul 2023",
      description:
        "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
      image:
        "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "Docker",
        "AWS",
        "DuckDNS",
        "Eslint",
        "Husky",
        "CI/CD",
        "React Js",
        "MongoDb",
        "Node Js",
        "Express Js",
        "Redux",
      ],
      category: "web app",
      github: "https://github.com/rishavchanda/Trackify",
      webapp: "https://trackify.duckdns.org",
    },
    {
      id: 0,
      title: "Podstream",
      date: "Apr 2023 - May 2023",
      description:
        "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
      image:
        "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
      tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
      category: "web app",
      github: "https://github.com/rishavchanda/Podstream",
      webapp: "https://podstream.netlify.app/",
      member: [
        {
          name: "Tushar Dupare",
          img: "https://avatars.githubusercontent.com/u/110093358?s=96&v=4",
          linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
          github: "https://github.com/rishavchanda/",
        },
      ],
    },
    {
      id: 1,
      title: "Vexa",
      date: "Oct 2022 - Present",
      description:
        "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
      image:
        "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
      tags: [
        "React Js",
        "MongoDb",
        "Node Js",
        "Express Js",
        "Redux",
        "NodeMailer",
      ],
      category: "web app",
      github: "https://github.com/rishavchanda/Project-Management-App",
      webapp: "https://vexa-app.netlify.app/",
    },
    {
      id: 2,
      title: "Brain Tumor Detection",
      date: "Jan 2023 - Mar 2023",
      description:
        "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
      image:
        "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
      tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
      category: "machine learning",
      github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
      webapp: "https://brain-tumor.netlify.app/",
      member: [
        {
          name: "Tushar Dupare",
          img: "https://avatars.githubusercontent.com/u/110093358?s=96&v=4",
          linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
          github: "https://github.com/rishavchanda/",
        }
      ],
    },
    {
      id: 3,
      title: "Buckoid",
      date: "Dec 2021 - Apr 2022",
      description:
        "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
      image:
        "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
      tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
      category: "android app",
      github: "https://github.com/rishavchanda/Buckoid-Android-App",
      webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
    },
    {
      id: 10,
      title: "Job Finding App",
      date: "Jun 2023 - Jul 2023",
      description:
        "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
      image:
        "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
      tags: ["React Native", "JavaScript", "Axios"],
      category: "android app",
      github: "https://github.com/rishavchanda/Job-finder-App",
      webapp: "https://github.com/rishavchanda/Job-finder-App",
    },
    {
      id: 4,
      title: "Whatsapp Clone",
      date: "Jul 2021",
      description:
        "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
      tags: ["React Js", "Firebase", "Firestore", "Node JS"],
      category: "web app",
      github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
      webapp: "https://whatsapp-clone-rishav.web.app",
    },
    {
      id: 5,
      title: "Todo Web App",
      date: "Jun 2021",
      description:
        " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
      image:
        "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
      tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
      category: "web app",
      github: "https://github.com/rishavchanda/Todo-Web-App",
      webapp: "https://rishav-react-todo.netlify.app/",
    },
    {
      id: 6,
      title: "Breaking Bad",
      date: "Jun 2021",
      description:
        "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
      image:
        "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
      tags: ["React Js", "API", "Axios", "Node JS"],
      category: "web app",
      github: "https://github.com/rishavchanda/Breaking-Bad",
      webapp: "https://breaking-bad-webapp.netlify.app",
    },
    {
      id: 7,
      title: "Quiz App",
      date: "Dec 2020 - Jan 2021",
      description:
        "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
      image:
        "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
      tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
      category: "android app",
      github: "https://github.com/rishavchanda/Quiz-Earn",
      webapp: "https://github.com/rishavchanda/Quiz-Earn",
    },
    {
      id: 8,
      title: "Face Recognition",
      date: "Jan 2021",
      description:
        "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
      image:
        "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
      tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
      category: "machine learning",
      github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
      webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];
